/*
 statistics api
*/

import axios from "../axios/axios";

export function getTrustHourlyApi(params) {
  return axios.post('/stats/trusthourly', params);
}

export function getPostCountLightApi(params) {
  return axios.post('/content/getPostCountLight', params);
}

export function getPostCountApi(params) {
  return axios.post('/content/getPostCount', params);
}

export function getTrustDailyApi(params) {
  return axios.post('/stats/trustdaily', params);
}

export function getTrustCommentDailyApi(params) {
  return axios.post('/stats/commenttrustdaily', params);
}

export function getStatsApi(params) {
  return axios.post('/stats', params);
}

export function getStatsAgesApi(params) {
  return axios.post('/stats/ages', params);
}

export function getThematicRatioApi(params) {
  return axios.post('/thematics/getThematicRatio', params);
}

export function getStatsAgeApi(params) {
  return axios.post('/stats/age', params);
}

export function getActiveSubscribersApi(params) {
  return axios.post('/stats/userlinks', params);
}

export function getCityApi(params) {
  return axios.post('/thread/getthreadcitylist', params);
}

export function getCityReportApi(params) {
  return axios.post('/thread/getcityreport', params);
}

export function addSinonymApi(params) {
  return axios.post('/threads/addsinonym', params);
}

export function getCityTopApi(params) {
  return axios.post('/thread/getcitytop', params);
}

export function GetXlsLink(params) {
  return axios.post('/stats/userlinks', params);
}

export function getAnalyticsApi(params) {
  return axios.post('/stats/analytics', params);
}
